// IE & Edge prevent scrolling bouncing of scrollmagic's parallax effects
// source https://benoit.rospars.me/snippets/ie-jumpy-bg

if (navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge/)) { // if IE and Edge
  const body = document.getElementsByTagName('body')[0]
  body.addEventListener('wheel', function (event) {
    event.preventDefault()
    const wheelDelta = event.deltaY
    const currentScrollPosition = window.pageYOffset
    window.scrollTo(0, currentScrollPosition + wheelDelta)
  })
}

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector ||
    Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    let el = this

    do {
      if (el.matches(s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}
